// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.H1 = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.H1 = void 0;
  _react = _interopRequireWildcard(_react);
  var React = _react;
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var H1 = _exports.H1 = function H1(props) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      d: "M3.98 8.318h6.143v3.9c0 1.495-.098 1.624-1.268 1.657v.406h3.997v-.406c-1.153-.033-1.25-.162-1.25-1.658V4.565c0-1.511.08-1.609 1.25-1.658V2.5H8.856v.406c1.186.049 1.268.147 1.268 1.658v3.234H3.98V4.564c0-1.511.081-1.609 1.267-1.658V2.5H1.25v.406c1.17.049 1.251.147 1.251 1.658v7.653c0 1.512-.097 1.625-1.251 1.658v.406h3.997v-.406c-1.17-.033-1.267-.162-1.267-1.658zM15 17.5h3.75v-.352c-.783-.036-.838-.049-1.003-.17-.192-.146-.247-.388-.247-1.201v-3.605c0-1.432.041-2.463.11-3.422-.673.146-1.566.255-2.61.316v.351h.522c.343 0 .508.025.618.11s.11.085.137 1.14v5.11c0 .874-.068 1.128-.37 1.25-.179.072-.316.085-.907.121z"
    }));
  };
});
